import {
  Map
} from 'immutable'

export default class FieldSetSchema extends Map {
  constructor(initialOptions) {
    super(initialOptions)
    this.set('id', this.get('id', `__schemer_field_set_${Date.now()}`))
  }

  getId() {
    return this.get('id')
  }
}

